import React from 'react';
import { LinearProgress, makeStyles } from '~/lib/bn-material-ui';
import { useSirenEntity } from '~/utility/BinSentry-ui-utility';
import classnames from 'classnames';
import { useLatestBinLevel } from './use-bin-level';

const useStyles = makeStyles((theme) => {
  return {
    base: {
      background: 'inherit',
      height: '100%',
      width: '100%',
      borderRadius: '4px',
      border: `${theme.palette.gray[60]} solid 2px`,
    },
    barContainer: {
      position: 'relative',
      width: '100%',
      height: '100%',
      overflow: 'hidden',
    },
    ok: {
      background: theme.palette.green[15],
    },
    warn: {
      background: theme.palette.orange[20],
    },
    critical: {
      background: theme.palette.red[20],
    },
    fillBar: {
      position: 'absolute',
      bottom: 0,
    },
  };
});

export function BinProfileIngredient({ href, className, horizontal }) {
  const styles = useStyles();

  const { entity: bin } = useSirenEntity({ href });
  const { volume, loading } = useLatestBinLevel({ binId: href });

  if (!bin || loading) {
    return <LinearProgress />;
  }

  const { fullTotal } = bin.properties.volumes;

  const percent = Number.isFinite(fullTotal) ? (volume / fullTotal) * 100 : 0;
  const fill = percent > 50 ? 'ok' : percent > 30 ? 'warn' : 'critical';

  const style = {};

  if (horizontal) {
    style.height = '100%';
    style.width = `${percent}%`;
  } else {
    style.height = `${percent}%`;
    style.width = '100%';
  }

  return (
    <div className={styles.base}>
      <div className={classnames(styles.barContainer, className)}>
        <div className={classnames(styles.fillBar, styles[fill])} style={style} />
      </div>
    </div>
  );
}
